/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Detail_Label_ReasonInputs */

const vi_sl_detail_label_reason = /** @type {(inputs: Sl_Detail_Label_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lý do`)
};

/**

* @param {Sl_Detail_Label_ReasonInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_detail_label_reason = /** @type {((inputs?: Sl_Detail_Label_ReasonInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Detail_Label_ReasonInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_detail_label_reason(inputs)
});